var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "power-box-wrap" }, [
    _c("div", { staticClass: "power-box" }, [
      _c("div", { staticClass: "bg-img" }),
      this.$route.query.msg
        ? _c("div", { staticClass: "texts" }, [
            _vm._v("抱歉，" + _vm._s(this.$route.query.msg))
          ])
        : _c(
            "div",
            {
              staticClass: "texts",
              style: {
                paddingBottom:
                  _vm.enterprise.default.ID && _vm.adminList.length
                    ? "80px"
                    : "20px"
              }
            },
            [_vm._v("抱歉，你暂无相关权限")]
          ),
      _vm.enterprise.default.ID
        ? _c("div", { staticClass: "hints" }, [
            _vm._v("请联系本公司管理员分配权限:")
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "cent" },
        _vm._l(_vm.adminList, function(item, index) {
          return _c("div", { key: index, staticClass: "items" }, [
            _c("div", { staticClass: "img" }),
            _c("div", { staticClass: "name" }, [_vm._v(_vm._s(item.Name))])
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }